<template>
    <section>
        <div id="TroubleshootCalendar" class="w-full h-[100vh] bg-white overflow-y-auto"></div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'


import { getCalendarData } from '@/util/calendar_modal'
import { mountCalendarSettingsApp, unmountCalendarSettingsApp } from '@/util/calendar_settings'
import store from '@/store'



export default defineComponent({
    name: 'TroubleshootCalendarPage',
    data() {
        return {
            currentLocationId: '',
        }
    },
    computed: {
        calendars(): string {
            return this.$store.state.calendars?.calendars
        },
    },
    watch: {
        '$route.params.location_id': async function (id) {
            this.currentLocationId = id
            this.mountTroubleshootCalendarApp()
        },
    },
    async created() {
        this.currentLocationId = this.$router.currentRoute.value.params.location_id
    },
    async mounted() {
        this.mountTroubleshootCalendarApp()
    },
    methods: {
        async getData() {
            const location = store.state.locations?.currentLocation || {}
            const user = store.state.user?.user || {}
            return {
                calendars: this.calendars,
                groups: store.state.teams?.teams,
                users: store.state.users?.users,
                locationDetails: location,
                loggedInUserInfo: user,
            }
        },
        async mountTroubleshootCalendarApp() {
            const data = await getCalendarData(this.currentLocationId);
            mountCalendarSettingsApp('TroubleshootCalendar', {
                route: this.$route,
                router: this.$router,
                locale: data.locale,
                locationId: this.currentLocationId,
                getData: this.getData
            })
        },
        async unmountTroubleshootCalendarApp() {
            unmountCalendarSettingsApp('TroubleshootCalendar')
        }
    }
})
</script>
